// Metamark M4 Vinyl kleurenpalette — geschikt voor zowel Mat als Glas afwerking.
// Hex-waarden zijn dichtbenadering van de officiële Metamark M4 kleurenkaart.
export const STICKER_COLORS = [
    // Neutralen
    { name: "Wit",              hex: "#FFFFFF" },
    { name: "Zwart",            hex: "#1A1A1A" },
    { name: "Licht Grijs",      hex: "#C8C8C8" },
    { name: "Storm Grijs",      hex: "#6E7174" },
    { name: "Donker Grijs",     hex: "#4A4A4A" },
    { name: "Eierschaal",       hex: "#F0EAD6" },
    { name: "Amandel",          hex: "#D5C7AD" },
    // Geel & oranje
    { name: "Citroen",          hex: "#FFF44F" },
    { name: "Midden Geel",      hex: "#FFCC00" },
    { name: "Boterbloem",       hex: "#F4B400" },
    { name: "Meloen",           hex: "#FFA858" },
    { name: "Oranje",           hex: "#FF7900" },
    // Rood & roze
    { name: "Klaproos",         hex: "#E83F2D" },
    { name: "Kers",             hex: "#C8102E" },
    { name: "Karmijn",          hex: "#A6192E" },
    { name: "Vlammend Rood",    hex: "#D2362C" },
    { name: "Roze",             hex: "#F472B6" },
    { name: "Magenta",          hex: "#BF1B7E" },
    // Groen
    { name: "Limoen",           hex: "#C4D600" },
    { name: "Klavergroen",      hex: "#009A44" },
    { name: "Midden Groen",     hex: "#00843D" },
    { name: "Bosgroen",         hex: "#154734" },
    { name: "Olijf",            hex: "#4A5D23" },
    { name: "Weide",            hex: "#7AB55C" },
    // Blauw & teal
    { name: "Hemel",            hex: "#6CACE4" },
    { name: "Marina",           hex: "#006298" },
    { name: "Teal",             hex: "#00838F" },
    { name: "Kobalt",           hex: "#003DA5" },
    { name: "Ultramarijn",      hex: "#1F2A78" },
    { name: "Oceaan",           hex: "#0033A0" },
    // Paars & metallics
    { name: "Paars",            hex: "#7B2CBF" },
    { name: "Bruin",            hex: "#6F4E37" },
    { name: "Zilver Metallic",  hex: "#C0C0C0" },
    { name: "Goud Metallic",    hex: "#D4AF37" },
];

// Modern fonts voor de sticker-ontwerper
export const STICKER_FONTS = [
    { id: "inter",      label: "Inter (Sans)",     css: "'Inter', system-ui, sans-serif" },
    { id: "bebas",      label: "Bebas Neue (Bold)", css: "'Bebas Neue', 'Arial Narrow', sans-serif" },
    { id: "pacifico",   label: "Pacifico (Script)", css: "'Pacifico', cursive" },
];
